const gfxPath = ADV.settings.endpoints.imgDir + 'chart_sprites/';

const chartDescriptors = {
    CashFlowDonut: {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            backgroundColor: 'transparent'
        },
        title: {
            text: ''
        },
        tooltip: {
            enabled: false,
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
            pie: {
                borderRadius: 0,
                size: 245 * .60,
                innerSize: 170 * .60,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return this.point.name.replace(/\/|\s/g, '<br/>') + ': <br/>' + Math.round(this.percentage) + ' %';
                    },
                    style: {"fontSize": "14px", "fontWeight": "300", "font-family": "'Open Sans'"},
                    distance: 12
                }
            },
            series: {
                cursor: 'pointer'
            }
        },
        series: [
            {
                type: 'pie',
                data: []
            }
        ],
        credits: {
            enabled: false
        }
    },
    CurrentAssetAllocationDonut: {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            backgroundColor: 'transparent',
            spacing: [0, 0, 0, 0]
        },
        title: {
            text: ''
        },
        legend: {
            layout: 'vertical',
            verticalAlign: 'middle',
            align: 'right',
            useHTML: true,
            labelFormatter: function () {
                return `<b>${ADV.util.number_format(this.y * 100)}%</b> <span style='color:#afb0b5'>${this.name}</span>`
            },
            itemStyle: {
                fontSize: '14px',
                fontWeight: '300',
                color: '#444444',
                fontFamily: 'Open Sans, helvetica, sans-serif'
            }
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            pie: {
                borderRadius: 0,
                slicedOffset: 0,
                size: '100%',
                innerSize: '70%',
                dataLabels: {
                    enabled: false
                },
                allowPointSelect: false,
                point: {
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    }
                },
                showInLegend: true
            },
            series: {
                states: {
                    hover: {
                        enabled: false
                    }
                }
            }
        },
        series: [
            {
                type: 'pie',
                name: 'Asset Allocation',
                data: []
            }
        ],
        credits: {
            enabled: false
        }
    },
    ApexAssetAllocationDonut: {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            backgroundColor: 'transparent',
            spacing: [0, 0, 0, 0]
        },
        title: {
            text: ''
        },
        legend: {
            layout: 'vertical',
            verticalAlign: 'middle',
            align: 'right',
            useHTML: true,
            labelFormatter: function () {
                return `<div class="legend-percentage">${ADV.util.number_format(this.y * 100)}%</div>`
                    + `<div class="legend-label">${this.name}</div>`
            },
            itemStyle: {}
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            pie: {
                borderRadius: 0,
                slicedOffset: 0,
                size: '100%',
                innerSize: '70%',
                dataLabels: {
                    enabled: false
                },
                allowPointSelect: false,
                point: {
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    }
                },
                showInLegend: true
            },
            series: {
                states: {
                    hover: {
                        enabled: false
                    }
                }
            }
        },
        series: [
            {
                type: 'pie',
                name: 'Asset Allocation',
                data: []
            }
        ],
        credits: {
            enabled: false
        }
    },
    RiskToleranceAssetAllocationDonut: {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            backgroundColor: 'transparent',
            spacing: [0, 0, 0, 0]
        },
        title: {
            text: ''
        },
        legend: {
            layout: 'vertical',
            verticalAlign: 'middle',
            align: 'right',
            useHTML: true,
            labelFormatter: function () {

                return `
                    <div class="label-container">
                        <div class="legend-label">${this.name}</div>
                        <div class="legend-percentage">${ADV.util.number_format(this.y * 100)}%</div>
                    </div>
                `;
            },
            itemStyle: {},
            symbolHeight: 14,
            symbolWidth: 14,
            symbolRadius: 7,
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            pie: {
                borderRadius: 0,
                slicedOffset: 0,
                size: '100%',
                innerSize: '65%',
                dataLabels: {
                    enabled: false
                },
                allowPointSelect: false,
                point: {
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    }
                },
                showInLegend: true
            },
            series: {
                states: {
                    hover: {
                        enabled: false
                    }
                }
            }
        },
        series: [
            {
                type: 'pie',
                name: 'Asset Allocation',
                data: []
            }
        ],
        credits: {
            enabled: false
        }
    },


    EmergencyFundBar: {
        chart: {
            type: 'bar',
            spacingLeft: 20,
            spacingRight: 20,
            spacingBottom: 0
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        yAxis: {
            title: {
                text: '',
                margin: 20,
                lineWidth: 0
            },
            labels: {
                formatter: function () {
                    return ADV.util.short_number_format(this.value);
                },
                style: {
                    fontFamily: 'Open Sans, helvetica, sans-serif',
                    fontSize: '13px',
                    color: '#888'
                }
            },
            gridLineColor: '#ddd',
            gridLineDashStyle: 'Dot',
            gridLineWidth: 2,
            maxPadding: 0,
            tickAmount: 8
        },
        xAxis: {
            title: {
                text: ''
            },
            labels: {
                enabled: false
            },
            lineWidth: 0,
            maxPadding: 0,
            tickLength: 0
        },
        series: [
            {
                name: 'Recommended Reserve',
                data: [],
                color: '#e5f8ff',
                fillOpacity: 1,
                borderColor: '#5abee4',
                borderWidth: 2
            }, {
                name: 'Current Reserve',
                color: '#5abee4',
                fillOpacity: 1,
                data: [],
                borderColor: '#5abee4',
                borderWidth: 2
            }
        ],
        tooltip: {
            enabled: false
        },
        plotOptions: {
            bar: {
                grouping: false,
                shadow: false,
                borderWidth: 0,
                states: {
                    hover: {
                        enabled: false
                    }
                }
            },
            series: {
                pointWidth: 90
            }
        }
    },
    EducationProgressBar: {
        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        xAxis: {
            categories: [],
            gridLineWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#ddd',
            gridLineDashStyle: 'Dot',
            gridLineWidth: 2,
            labels: {
                formatter: function () {
                    return '$' + ADV.util.short_number_format(this.value);
                },
                style: {
                    fontFamily: 'Open Sans, helvetica, sans-serif',
                    fontSize: '13px',
                    color: '#888'
                }
            }
        },
        series: [
            {
                name: 'Expenses',
                data: [],
                color: '#e5f8ff',
                fillOpacity: 1,
                borderColor: '#5abee4',
                borderWidth: 2
            }, {
                name: 'Expenses Covered',
                color: '#5abee4',
                fillOpacity: 1,
                data: []
            }
        ],
        tooltip: {
            useHTML: true,
            shadow: false,
            borderWidth: 0,
            backgroundColor: "rgba(255,255,255,0)",
            borderRadius: 0,
            formatter: function () {
                return '<div><strong>' + this.series.name + '</strong><br>' + this.x + ' / $' + ADV.util.number_format(this.y, 0) + '</div>';
            }
        },
        plotOptions: {
            column: {
                grouping: false,
                shadow: false,
                borderWidth: 0
            }
        }
    },
    NetWorthDonutChart: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                borderRadius: 0,
                size:245,
                innerSize:170,
                dataLabels:{
                    enabled:true,
                    useHTML: true,
                    formatter: function() {
                        return '<div class="chart-label">'+ this.point.name +'\xa0'+ Math.round(this.percentage) +'%</div>';
                    },
                    distance: 20
                },
                events: {
                    click: function(event){
                        //select tab
                        $('#accounts-subnav').find('li').each(function(){
                            var $this = $(this);
                            if($this.html() == event.point.name){
                                $this.trigger('click');
                            }
                        });
                    }
                }
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    }
}

export var CashFlowDonut = chartDescriptors.CashFlowDonut
export var CurrentAssetAllocationDonut = chartDescriptors.CurrentAssetAllocationDonut
export var ApexAssetAllocationDonut = chartDescriptors.ApexAssetAllocationDonut
export var RiskToleranceAssetAllocationDonut = chartDescriptors.RiskToleranceAssetAllocationDonut
export var EmergencyFundBar = chartDescriptors.EmergencyFundBar
export var EducationProgressBar = chartDescriptors.EducationProgressBar
export var NetWorthDonutChart = chartDescriptors.NetWorthDonutChart

export default chartDescriptors
